// removed by extract-text-webpack-plugin
module.exports = {"form":"c-ConsentGroupForm__form"};